module.exports = __webpack_public_path__ + "static/media/lt.76ec6661.svg";